import ReviewsLegalModal from './ReviewsLegalModal.vue'

export default ReviewsLegalModal
